<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full max-h-screen mx-1 sm:w-2/3">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Delivery and Invoice Dates
			</div>
			<div class="p-4 overflow-auto" style="max-height: 80vh" v-if="Object.keys(fetchedForecastOrders).length">
				<div class="space-y-2" v-if="fetchedForecastOrders">
					<div class="mb-2 flex items-center px-2">
						<div class="flex-1 mr-2">
							&nbsp;
						</div>
						<div class="mr-2 w-52">
							Delivery Date
						</div>
						<div class="mr-2 w-52">
							Invoice Date
						</div>
					</div>
					<div class="flex items-center p-4 bg-gray-100 rounded" v-for="(details, supplier) in fetchedForecastOrders">
						<h2 class="flex-1 font-bold text-black">{{ supplier }}</h2>
						<div class="mr-2 w-52">
							<datetime type="date" value-zone="local" class="" placeholder="Delivery Date" id="start_datetime" v-model="details.delivery_date"></datetime>
						</div>
						<div class="mr-2 w-52">
							<datetime type="date" value-zone="local" class="" placeholder="Invoice Date" id="start_datetime" v-model="details.invoice_date"></datetime>
						</div>
					</div>
				</div>
			</div>
			<div class="p-4 overflow-auto" style="max-height: 80vh" v-else>
				No supplier orders pending
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Save</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['show','regionid'],
	data () {
		return {
			fetchedForecastOrders: [],
			products: [],
			selected: null,
      		searchText: '',
		}
	},
	methods: {
		checkForErrors () {},
		cancel () {
			this.$emit('close')
		},
		save () {
			if (this.checkForErrors()) return;
			
			this.$http.post(`forecasts/${this.regionid}/delivery_dates/`, {
					'orders': this.fetchedForecastOrders,
				})
				.then(response => {
					let success = {
						title: 'Action Successful',
						message: 'Dates saved successfully!',
						type: 'success'
					}
					this.$store.commit('setStatus', success)	
					this.$emit('reload')
					this.$emit('close')
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	computed: {
		
	},
	components: {
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});

		this.$http.get(`/forecasts/${this.regionid}/pending_forecastorders_by_region`).then((response) => {
			let fetched = response.data.orders;
			let today = new Date();
			let tomorrow = new Date(today);
			tomorrow.setDate(tomorrow.getDate() + 1);
			let offset = today.getTimezoneOffset();
			let nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
			nextMonth = new Date(nextMonth.getTime() - (offset*60*1000));
			
			let shiftInvoiceToNextMonth = today.getDate() > 25;
			

			for (const [key, value] of Object.entries(fetched)) {
				console.log(new Date(value.delivery_date.replace(' ', 'T')+'Z'));
				fetched[key]['delivery_date'] = value.delivery_date ? new Date(value.delivery_date.replace(' ', 'T')+'Z').toISOString() : tomorrow.toISOString().split('T')[0];
				fetched[key]['invoice_date'] = value.invoice_date ? new Date(value.invoice_date.replace(' ', 'T')+'Z').toISOString() : (shiftInvoiceToNextMonth ? nextMonth.toISOString().split('T')[0] : today.toISOString().split('T')[0]);
			}

			this.fetchedForecastOrders = fetched;
		})
	}
}
</script>
